// If you are making changes to this page you MUST update this confluence page as well to pass code review:
// https://southwest.atlassian.net/wiki/spaces/STARTEC/pages/63767987/Error+Codes

export const genericErrorCodeToErrorMessageMap = {
  genericError: { message: "STARS app has encountered an Error. Please log out and try again.", code: "E1009" },
};

export const loginErrorCodeToErrorMessageMap = {
  // Error during Ping Server Redirect
  pingServerRedirectError: { message: "Error during STARS login! Please try again.", code: "E1001" },
  // Error pulling User Session Data together
  userSessionDataPullError: { message: "Error during STARS login! Please try again.", code: "E1002" },
  // Error getting Access Token with Auth Code
  accessTokenError: { message: "Error during STARS login! Please try again.", code: "E1003" },
  // Error where url has query string params but authCode is not present, unknown query strings in the url?
  unknownQueryStringError: { message: "Error during STARS login! Please try again.", code: "E1004" },
};

export const tradeDataErrorCodeToErrorMessageMap = {
  // Error during TradeAdministrationPage; payload size was too big
  tradeDataMaxPayloadError: {
    message: "Too many trades came back. Please narrow your date range.",
    code: "E1005",
  },
  // Unexpected error during TradeAdministrationPage trade data pull
  unexpectedTradeDataError: { message: "Unexpected error occurred. Please refresh your browser.", code: "E1006" },
};

export const timeOffRequestDataErrorCodeToErrorMessageMap = {
  // Error during TimeOffRequestAdministrationPage; payload size was too big
  timeOffRequestDataMaxPayloadError: {
    message: "Too many time off requests came back. Please narrow your date range.",
    code: "E1007",
  },
  // Unexpected error during TimeOffRequestAdministrationPage time off request data pull
  unexpectedTimeOffRequestDataError: {
    message: "Unexpected error occurred. Please refresh your browser.",
    code: "E1008",
  },
};

export const tempAssignmentDataErrorCodeToErrorMessageMap = {
  // Error during TemporaryAssignmentAdministrationPage; payload size was too big
  maxPayloadError: {
    message: "Too many temp assignments came back. Please narrow your date range.",
    code: "E1011",
  },
  // Unexpected error during TemporaryAssignmentAdministrationPage temp assignment data pull
  unexpectedError: { message: "Unexpected error occurred. Please refresh your browser.", code: "E1012" },
};

export const seniorityDataErrorCodeToErrorMessageMap = {
  // Unexpected error during SeniorityListPage seniority data pull
  unexpectedSeniorityDataError: { message: "Unexpected error occurred. Please refresh your browser.", code: "E1010" },
};

export const bidDataErrorCodeToErrorMessageMap = {
  // Error during BidAdministrationPage; payload size was too big
  bidDataMaxPayloadError: {
    message: "Too many bids came back. Please narrow your date range.",
    code: "E1013",
  },
  // Unexpected error during BidAdministrationPage bid data pull
  unexpectedBidDataError: { message: "Unexpected error occurred. Please refresh your browser.", code: "E1014" },
  bidAwardError: {
    message: "Please try again in a few minutes.",
    code: "E1015",
  },
  IAOBidAwardError: {
    message: "An unexpected error occurred during the IAO Bid Award.",
    code: "E1016",
  },
};

export const declarationsDataErrorCodeToErrorMessageMap = {
  // Unexpected error during Declarations data pull
  unexpectedDeclarationsDataError: {
    message: "Unexpected error occurred. Please refresh your browser.",
    code: "E1017",
  },
};

export const overtimeDataErrorCodeToErrorMessageMap = {
  // Unexpected error during Overtime data pull
  unexpectedOvertimeDataError: {
    message: "Unexpected error occurred. Please refresh your browser.",
    code: "E1018",
  },
};
